import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ManagePicTransactions.Title',
    defaultMessage: 'Manage PIC Transactions',
  },
  generateSubmissionFile: {
    id: 'App.ManagePicTransactions.GenerateSubmissionFile',
    defaultMessage: 'Generate Submission File',
  },
  generating: {
    id: 'App.ManagePicTransactions.Generating',
    defaultMessage: 'Generating…',
  },
  generateSubmissionFileSuccess: {
    id: 'App.ManagePicTransactions.GenerateSubmissionFile.Success',
    defaultMessage: 'Submission file generated.',
  },
  comingSoon: {
    id: 'App.ManagePicTransactions.GenerateSubmissionFile.ComingSoon',
    defaultMessage: 'Coming soon',
  },
  generateReport: {
    id: 'App.ManagePicTransactions.GenerateReport',
    defaultMessage: 'Generate Report',
  },
  headOfHousehold: {
    id: 'App.ManagePicTransactions.HeadOfHousehold',
    defaultMessage: 'Head of Household',
  },
  unitNumber: {
    id: 'App.ManagePicTransactions.UnitNumber',
    defaultMessage: 'Unit',
  },
  certificationType: {
    id: 'App.ManagePicTransactions.CertificationType',
    defaultMessage: 'Cert Type',
  },
  effectiveDate: {
    id: 'App.ManagePicTransactions.EffectiveDate',
    defaultMessage: 'Effective Date',
  },
  certificationCompletionDate: {
    id: 'App.ManagePicTransactions.CertificationCompletionDate',
    defaultMessage: 'Cert Completion Date',
  },
  status: {
    id: 'App.ManagePicTransactions.Status',
    defaultMessage: 'Generated',
  },
  mustSelectOneRow: {
    id: 'App.ManagePicTransactions.mustSelectOneRow',
    defaultMessage: 'There are no certifications selected.',
  },
});

export default messages;
